/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { AnalyticsService } from './@core/utils/analytics.service';
import { SeoService } from './@core/utils/seo.service';
@Component({
  selector: 'pwa-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  constructor(
    private analytics: AnalyticsService,
    private seoService: SeoService,
    private logger: NGXLogger,
  ) {}

  ngOnInit() {
    this.analytics.trackPageViews();
    this.seoService.trackCanonicalChanges();
    this.logger.debug('new Date()', new Date());
    this.logger.debug(
      'new Date().toLocaleString()',
      new Date().toLocaleString(),
    );
    this.logger.debug(
      `new Date("2021-01-01T12:00:00+0200".substr(0, 19)).toLocaleString())`,
      new Date('2021-01-01T12:00:00+0200'.substr(0, 19)).toLocaleString(),
    );
  }
}
